{
  "hero": {
    "subtitle": "Live Практики · 24/7",
    "headline": "Социальная платформа, объединяющая людей",
    "headlineHighlight": "на пути развития.",
    "tagline": "Мастера, Live-сессии, ретриты, AI-помощник, личный календарь и окружение, которое поддерживает вашу эволюцию. Онлайн и офлайн, в любой точке мира.",
    "stat1Num": "Live-сессии",
    "stat1Label": "С мастерами 24/7",
    "stat2Num": "Сообщество",
    "stat2Label": "Единомышленники рядом",
    "stat3Num": "События",
    "stat3Label": "По всему миру",
    "valueProp1": "Живые практики с мастерами",
    "valueProp2": "24/7 · Всегда на связи",
    "valueProp3": "ИИ подбор практик",
    "startPractice": "Начать",
    "exploreSchedule": "Календарь",
    "backLink": "← Назад",
    "joinLiveNow": "Подключиться",
    "viewProfile": "Профиль →",
    "viewProfileNative": "Профиль",
    "description": "Социальная платформа для тех, кто практикует. Мастера мирового уровня, Live-сессии и записи практик, онлайн- и офлайн-события и сообщество, разделяющее ваш путь."
  },
  "agapeBanner": {
    "overline": "ОТКРЫТАЯ ПРАКТИКА",
    "titleBefore": "Практика ",
    "titleHighlight": "Агапэ",
    "titleAfter": "",
    "subheadline": "15 минут, которые возвращают к себе. Тишина, ясность и тотальная перезагрузка.",
    "ctaJoin": "Хочу!",
    "ctaJoined": "МЫ ЖДЕМ ВАС",
    "inviteFriends": "Позвать друзей",
    "linkCopied": "Ссылка скопирована!",
    "shareMessage": "Приходи на Практику Agapē в это воскресенье"
  },
  "onboarding": {
    "focusTitle": "Ваш фокус?",
    "goalTitle": "Ваша цель?",
    "timeTitle": "Предпочитаемое время?",
    "focusTitleShort": "Фокус?",
    "goalTitleShort": "Цель?",
    "timeTitleShort": "Когда?",
    "meditation": "Медитация",
    "yoga": "Йога",
    "breathing": "Дыхание",
    "focus": "Фокус",
    "relaxation": "Релаксация",
    "wellbeing": "Благополучие",
    "clarity": "Ясность",
    "energy": "Энергия",
    "sleep": "Сон",
    "morning": "Утро",
    "afternoon": "День",
    "evening": "Вечер",
    "night": "Ночь",
    "recorded": "Записи",
    "live": "Live-сессии",
    "next": "ДАЛЕЕ",
    "finish": "ГОТОВО",
    "back": "НАЗАД"
  },
  "startingSoon": {
    "featuresTitleBefore": "Возможности ",
    "featuresTitleAfter": "",
    "overline": "Прямо сейчас",
    "title": "Сейчас идут Live-сессии",
    "subtitle": "Подключайтесь к Live-сессиям, которые идут прямо в этот момент.",
    "joinNow": "ПРИСОЕДИНИТЬСЯ",
    "joinNowBtn": "Войти",
    "noSessions": "Сейчас все мастера отдыхают.",
    "exploreSchedule": "КАЛЕНДАРЬ",
    "capabilitiesTitle": "Возможности Agapēlla",
    "capabilitiesSubtitle": "Пока нет Live-сессий, исследуйте платформу",
    "capabilitiesHint": "Всё, что нужно для вашей практики — в одном пространстве",
    "openCard": "Открыть",
    "features": {
      "createRoomTitle": "Создайте свою Live-сессию",
      "createRoomTagline": "Выберите практику, пригласите друзей — и практикуйте вместе в реальном времени",
      "findMasterTitle": "Найдите своего мастера",
      "findMasterTagline": "Эксперты в медитации, психологии, философии — ваш личный проводник",
      "findCircleTitle": "Найдите своё окружение",
      "findCircleTagline": "Единомышленники, совместные практики и события сообщества каждый день",
      "talkAgapellaTitle": "Поговорите с Agapella",
      "talkAgapellaTagline": "AI-помощник подберёт практику под настроение и создаст программу для вас",
      "calendarTitle": "Календарь событий",
      "calendarTagline": "Онлайн и оффлайн мероприятия по интересам. Agapella напомнит заранее",
      "libraryTitle": "Библиотека практик",
      "libraryTagline": "Медитации, дыхание, психология, философия — найдите практику для вас"
    }
  },
  "dailyRhythm": {
    "liveBadge": "ЭФИР",
    "liveNow": "LIVE",
    "min": "мин",
    "joinNowBtn": "Войти",
    "imGoing": "Я иду",
    "join": "Присоединиться",
    "noFilterThisDay": "{{label}} на этот день нет",
    "noMatchingEvents": "По фильтру событий нет",
    "otherEvents": "другие события ↓",
    "emptyMyTitle": "У вас нет запланированных событий",
    "emptyTitle": "Событий не найдено",
    "emptyMyDesc": "На этот день у вас нет запланированных событий.",
    "emptyDesc": "Расписание на этот день свободно.",
    "selectFromSchedule": "Выбрать из расписания",
    "title": "Ваша практика.",
    "titleHighlight": "Каждый день.",
    "subtitle": "Спланируйте свой путь. Выберите день для просмотра расписания.",
    "fullCalendar": "КАЛЕНДАРЬ",
    "allTraditions": "Все традиции",
    "tradition": "ТРАДИЦИЯ",
    "featured": "РЕКОМЕНДУЕМ",
    "agape": "AGAPÉ",
    "saveSpot": "Занять место",
    "lives": "Live-сессии",
    "events": "События",
    "loading": "Загрузка расписания...",
    "loadFailed": "Не удалось загрузить расписание",
    "noSessions": "Нет сессий на {{day}}.",
    "today": "Сегодня",
    "withMaster": "с {{name}}",
    "reminderSet": "Напоминание установлено",
    "reminderRemoved": "Напоминание удалено",
    "reminderFailed": "Не удалось обновить напоминание",
    "signUpNotify": "Зарегистрируйтесь, чтобы получить напоминание",
    "signUpSaveSpot": "Зарегистрируйтесь, чтобы занять место",
    "myCalendar": "Мой календарь",
    "filters": {
      "paths": "Направления",
      "livestreams": "Live-сессии",
      "livePractice": "Live-практика",
      "offline": "Офлайн",
      "all": "Все",
      "selectPath": "ВЫБЕРИТЕ НАПРАВЛЕНИЕ:"
    },
    "paths": {
      "meditation": "Медитация",
      "psychology": "Психология",
      "philosophy": "Философия",
      "body": "Телесные практики",
      "breathwork": "Дыхательные практики",
      "morning": "Утренняя практика",
      "sleep": "Перед сном",
      "traditions": "Традиции"
    },
    "formats": {
      "offline": "ОФЛАЙН",
      "online": "ОНЛАЙН",
      "livestream": "LIVE-СЕССИЯ",
      "liveroom": "LIVE-ПРАКТИКА"
    },
    "monthNames": [
      "Январь",
      "Февраль",
      "Март",
      "Апрель",
      "Май",
      "Июнь",
      "Июль",
      "Август",
      "Сентябрь",
      "Октябрь",
      "Ноябрь",
      "Декабрь"
    ],
    "dayNames": [
      "Вс",
      "Пн",
      "Вт",
      "Ср",
      "Чт",
      "Пт",
      "Сб"
    ]
  },
  "videoBlock": {
    "overline": "Платформа",
    "title": "Это",
    "titleHighlight": "Agapē",
    "headlineHighlight": "объединяет.",
    "tagline": "Социальная платформа нового формата для тех, кто практикует. Мастера, Live-сессии, сообщество и события — в одном пространстве.",
    "stat1Num": "Live Практики",
    "stat1Label": "Live-сессии с мастерами 24/7",
    "stat2Num": "Своё Окружение",
    "stat2Label": "Сообщество единомышленников",
    "stat3Num": "Онлайн и офлайн",
    "stat3Label": "События рядом с вами",
    "description": "Agapēlla — это среда, которая двигает вас вперёд. Находите мастеров и людей, с которыми развитие становится естественным."
  },
  "communityJoin": {
    "badge": "Мобильное приложение",
    "title": "Присоединяйтесь к",
    "titleHighlight": "сообществу Agapē",
    "description": "Практикуйте где угодно. Офлайн-медитации, трекинг прогресса и прямой доступ к мастерам — всегда под рукой.",
    "appStoreLabel": "Скачать в",
    "appStoreName": "App Store",
    "playStoreLabel": "ДОСТУПНО В",
    "playStoreName": "Google Play",
    "rating": "4.9/5 от 2,000+ участников"
  },
  "communityFeed": {
    "sectionLabel": "Сообщество",
    "postsFrom": "Публикации мастера",
    "you": "Вы",
    "pinned": "Закреплено мастером",
    "firstComment": "Будьте первым — оставьте комментарий",
    "addComment": "Напишите комментарий...",
    "sharePlaceholder": "Поделитесь чем-то с сообществом...",
    "newPost": "Новая публикация",
    "whatOnMind": "О чём вы думаете?",
    "audienceLabel": "Аудитория",
    "audiencePublic": "Для всех",
    "audienceSubscribers": "Для подписчиков",
    "postLockedTitle": "Эта публикация доступна подписчикам мастера",
    "postLockedBody": "Подпишитесь на {{name}}, чтобы её прочитать",
    "postLockedMaster": "мастера",
    "postLockedCta": "Подписаться на мастера",
    "postLockedSignIn": "Войдите, чтобы подписаться на мастера и прочитать публикацию.",
    "postGone": "Публикация недоступна: её удалили или скрыли.",
    "postLoadFailed": "Не получилось открыть публикацию.",
    "noPostsGuest": "Публикаций пока нет",
    "noPostsOwner": "Публикаций пока нет — поделитесь первой!",
    "post": "ОПУБЛИКОВАТЬ",
    "addPhoto": "Добавить фото",
    "addVideo": "Добавить видео",
    "photoAttached": "Фото прикреплено",
    "removePhoto": "Убрать фото",
    "photoLabel": "Фото",
    "videoLabel": "Видео",
    "uploadingVideo": "Загрузка… {{percent}}%",
    "processingVideo": "Обработка видео…",
    "currentVideo": "Текущее видео",
    "tooManyPhotos": "К посту можно прикрепить не более {{count}} фотографий",
    "photosOrVideo": "К посту можно прикрепить либо фотографии, либо видео — но не то и другое сразу",
    "eventChip": "СОБЫТИЕ",
    "onlineAnnouncementChip": "Анонс Онлайн сессии",
    "offlineEventChip": "Офлайн событие",
    "practiceChip": "ПРАКТИКА",
    "goTo": "Перейти",
    "join": "Присоединиться",
    "joined": "Я иду",
    "pin": "Закрепить",
    "unpin": "Открепить",
    "delete": "Удалить",
    "deleteConfirmTitle": "Удалить публикацию?",
    "deleteConfirmBody": "Публикация исчезнет у всех участников сообщества. Это действие нельзя отменить.",
    "deleteConfirmBodyDiscussion": "Публикация и её обсуждение исчезнут у всех участников вместе с перепиской. Это действие нельзя отменить.",
    "edit": "Редактировать",
    "edited": "Изменено",
    "readMore": "Читать далее",
    "close": "Закрыть",
    "save": "Сохранить",
    "cancel": "Отмена",
    "manageMenu": "Действия с публикацией",
    "share": "Поделиться",
    "loadFailed": "Не удалось загрузить ленту",
    "retry": "Повторить"
  },
  "theSpace": {
    "overline": "Возможности",
    "title": "Что внутри",
    "description": "Формат для современной жизни. Короткие и глубокие сессии с мастерами медитации, дыхания и психологии.",
    "liveStreams": "Live-сессии",
    "liveStreamsSubtitle": "Живая практика прямо сейчас.",
    "liveStreamsDesc": "Присоединяйтесь к сессиям в реальном времени с мастерами мирового уровня.",
    "liveStreamsBadge": "Всегда онлайн · 24/7",
    "liveStreamsAction": "Подключиться",
    "aiCompanion": "AI-компаньон",
    "aiCompanionSubtitle": "Личный наставник, всегда.",
    "aiCompanionDesc": "Обсудите, поставьте намерение и найдите подходящую практику.",
    "aiCompanionBadge": "Личное · По запросу",
    "aiCompanionAction": "Начать диалог",
    "agapePractices": "ПРАКТИКИ AGAPĒ",
    "agapePracticesSubtitle": "Курировано Agapē.",
    "agapePracticesDesc": "Одобренные Agapē сессии: медитация, фокус, баланс, благодарность.",
    "agapePracticesBadge": "Курировано · Agapē",
    "agapePracticesAction": "Исследовать практики",
    "communities": "Сообщества",
    "communitiesSubtitle": "Растите со своими.",
    "communitiesDesc": "Группы по интересам для связи и постоянства между сессиями.",
    "communitiesBadge": "Сообщество · Для участников",
    "communitiesAction": "Найти сообщества"
  },
  "practices": {
    "title": "Практики",
    "subtitle": "Выберите то, что нужно — фокус, покой, любовь или внутреннюю силу.",
    "exploreLibrary": "Вся библиотека",
    "allPractices": "Все практики",
    "meditation": "Медитация",
    "breathwork": "Дыхание",
    "movement": "Движение",
    "meditative": "Медитативные практики",
    "meditativeDesc": "Присутствие, тишина, внутренний простор для заземления.",
    "meditativeTag1": "Глубокое спокойствие",
    "meditativeTag2": "Открытое внимание",
    "meditativeBadge": "Медитативное",
    "neurofocus": "Нейрофокус",
    "neurofocusDesc": "Внимание, привычки и ясность ума для глубокой работы.",
    "neurofocusTag1": "90-сек перезагрузка",
    "neurofocusTag2": "Потоковое состояние",
    "neurofocusBadge": "Тренд",
    "stateDesign": "Дизайн состояний",
    "stateDesignDesc": "Осознанно установите эмоциональный и энергетический тон.",
    "stateDesignTag": "Утренняя настройка",
    "stateDesignBadge": "Дизайн",
    "somaticBreathwork": "Соматическое дыхание",
    "somaticBreathworkDesc": "Использование дыхания для снятия напряжения в теле.",
    "somaticBreathworkTag1": "Освобождение",
    "somaticBreathworkTag2": "Энергия",
    "somaticBreathworkBadge": "Тело",
    "sleepNonDoing": "Сон и не-делание",
    "sleepNonDoingDesc": "Практики для глубокого отдыха, засыпания и отпускания.",
    "sleepNonDoingTag1": "NSDR",
    "sleepNonDoingTag2": "Йога-нидра",
    "sleepNonDoingBadge": "Отдых",
    "communityCircles": "Круги сообщества",
    "communityCirclesDesc": "Совместное исследование и поддержка друг друга.",
    "communityCirclesTag": "Отношения",
    "communityCirclesBadge": "Совместное"
  },
  "masters": {
    "overline": "Наставники",
    "title": "Agapēlla — это среда,",
    "titleHighlight": "которая двигает вас вперёд.",
    "description": "Находите мастеров и людей, с которыми развитие становится естественным.",
    "exploreAll": "Все мастера",
    "masterBadge": "МАСТЕР",
    "fallbackDesc": "Мастер"
  },
  "schedule": {
    "title": "События и практики.",
    "titleHighlight": "В вашем ритме.",
    "subtitle": "От телесных практик до глубоких ретритов — находите форматы, которые откликаются вашему внутреннему состоянию.",
    "today": "Сегодня",
    "withMaster": "с {{name}}",
    "upcomingIntensive": "БЛИЖАЙШИЙ ИНТЕНСИВ"
  },
  "scheduleCalendar": {
    "eventsThisMonth": "{{count}} событие в этом месяце",
    "eventsThisMonth_plural": "{{count}} событий в этом месяце",
    "selectDate": "Выберите дату",
    "eventCount": "{{count}} событие",
    "eventCount_plural": "{{count}} событий",
    "noEvents": "Нет запланированных событий",
    "noEventsHint": "Выберите другую дату или месяц",
    "reminded": "Напомним",
    "remindMe": "Напомнить"
  },
  "aboutPlatformWidget": {
    "title": "Хотите узнать о возможностях нашей платформы?",
    "description": "Agapēlla — это пространство для практик, осознанных встреч и живого взаимодействия мастеров и участников.",
    "cta": "Узнать больше"
  },
  "circlesPreview": {
    "overline": "Окружение",
    "title": "Создай свое окружение",
    "subtitle": "Присоединяйся к нашим закрытым сообществам по интересам и философии. Найди своих людей, чтобы расти и развиваться вместе.",
    "exploreAll": "Все круги",
    "members": "участников"
  },
  "native": {
    "tabs": {
      "home": "Главная",
      "events": "События",
      "practices": "Практики",
      "masterFeed": "Лента\nмастера",
      "liveSession": "Live-\nсессия",
      "messages": "Сообщения",
      "profile": "Профиль"
    },
    "heroFallback": {
      "title": "Платформа знаний и практик в поддержку человека",
      "subtitle": "Живое общение с мастерами разных школ и традиций\nLive-сессии, библиотека видео и аудио практик на каждый день\nОнлайн и офлайн события, личный календарь\nAI-помощник для настройки вашего персонального опыта\nБережное окружение и сообщества, объединяющие людей на пути развития\n24/7 в любой точке мира"
    },
    "heroArt": {
      "dark": "Закат над озером, горы",
      "light": "Рассвет над озером, горы"
    },
    "closing": {
      "lead": "Ваша практика. ",
      "accent": "Каждый день."
    },
    "openPractice": {
      "label": "ОТКРЫТАЯ ПРАКТИКА",
      "title": "Практика Agapē",
      "description": "15 минут, которые возвращают к себе. Тишина, ясность и тотальная перезагрузка.",
      "want": "Хочу",
      "invite": "Позвать друзей"
    },
    "capabilitiesLead": "Возможности ",
    "capabilities": {
      "createRoom": {
        "title": "Создайте\nсвою Live-сессию",
        "description": "Выберите практику, пригласите друзей — и практикуйте вместе в реальном времени."
      },
      "masters": {
        "title": "Найдите\nсвоего мастера",
        "description": "Эксперты в медитации, психологии — ваш личный проводник."
      },
      "calendar": {
        "title": "Календарь\nпрактик",
        "description": "Онлайн и офлайн события каждый день."
      },
      "assistant": {
        "title": "AI-помощник",
        "description": "Тёплый собеседник рядом в любой момент дня."
      },
      "library": {
        "title": "Ваша\nбиблиотека",
        "description": "Избранные практики и записи под рукой."
      },
      "center": {
        "title": "Центр\nAgapē",
        "description": "Окружение, которое поддерживает вашу эволюцию."
      }
    },
    "sections": {
      "capabilities": "Возможности",
      "liveNow": "Сейчас идут Live-сессии",
      "upcomingEvents": "Ожидаемые события",
      "featuredMasters": "Мастера рядом",
      "newMasters": "Новые мастера",
      "upcomingFallback": "Ближайшие события",
      "newMedia": "Новые медиа",
      "news": "Новости Agapella"
    },
    "seeAll": "СМОТРЕТЬ ВСЕ",
    "seeAllShort": "Все →",
    "join": "Присоединиться",
    "audio": "Аудио",
    "online": "Онлайн",
    "offline": "Офлайн",
    "calendarChips": {
      "directions": "Направления",
      "live": "Live-сессия",
      "offline": "Офлайн"
    },
    "inviteMessage": "Присоединяйся к практике в Agapella — 15 минут тишины, которые возвращают к себе.",
    "pathInvite": {
      "title": "Следуй своему пути вместе с Agapella",
      "body": "Практики и поддержка — в удобном для тебя ритме.",
      "cta": "Начать путь"
    },
    "masters": {
      "follow": "Подписаться",
      "following": "Вы подписаны",
      "share": "Поделиться профилем",
      "followError": "Не удалось изменить подписку"
    },
    "seeAllLink": "Смотреть все",
    "upcoming": {
      "subtitle": "Live, онлайн- и офлайн-встречи в ближайшем расписании.",
      "rsvp": "Записаться",
      "open": "Открыть",
      "going": "Вы идёте",
      "unavailable": "Недоступно",
      "error": "Не удалось изменить участие. Попробуйте ещё раз."
    },
    "directions": {
      "title": "О ком и о чём мне хочется позаботиться сегодня?",
      "items": {
        "self": "Исследую, кто я",
        "calm": "Побеждаю тревогу и бессонницу",
        "morning": "Начинаю день в ресурсе",
        "health": "Выбираю заботу о здоровье",
        "close": "Хочу лучше понимать себя и близких",
        "support": "Ищу опору"
      }
    },
    "roulette": {
      "random": "Не знаю, с чего начать",
      "caption": "Случайный выбор",
      "spinning": "Выбираем направление…",
      "result": "Выбрано направление",
      "selected": "Выбрано",
      "open": "Перейти в направление"
    },
    "infoCards": {
      "assistantTitle": "Спросить Агапеллу",
      "assistantAction": "Начать разговор",
      "platformTitle": "Как работает платформа",
      "platformAction": "Узнать больше"
    },
    "news": {
      "read": "Читать",
      "open": "Открыть",
      "all": "Все материалы",
      "back": "Назад",
      "close": "Закрыть",
      "empty": "Новости пока не опубликованы."
    }
  }
}
